import { Pipe, PipeTransform } from '@angular/core';
import { formatMessage } from 'devextreme/localization';
import { VoteCardDeliveryInformation } from '../models/assemblea/assemblea-models';
import { PotentialAttendantRelationShipType } from '../models/assemblea/enums';
import { isnull, isNullOrUndefined } from '../utils/utils';

@Pipe({ name: 'VoteCardDeliveryInfoToRelIDText' })
export class VoteCardDeliveryInfoToRelIDText implements PipeTransform {
    transform(vcdi: VoteCardDeliveryInformation): string {
        if (isNullOrUndefined(vcdi)) {
            return "";
        }

        if (vcdi.RelID == PotentialAttendantRelationShipType.Shareholder) {
            return formatMessage("LABEL_FISICO", "");
        }
        else if (vcdi.RelID == PotentialAttendantRelationShipType.Delegation) {
            return formatMessage("LABEL_DELEGA", "");
        }
        else if (vcdi.RelID == PotentialAttendantRelationShipType.LegalRepresentation) {
            return isnull(vcdi.DescrizioneVincolo, formatMessage("LABEL_RAPPR_LEGALE", ""));
        }

        return "";
    }
}
